import { lazy } from "react";
import type { RouteObject } from "react-router";
import type { AppModule, SettingsSection } from "../types";
import { Lazy } from "./components/Layout";
import { s } from "./strings";

const GeneralLazy = lazy(() => import("./sections/General").then((m) => ({ default: m.GeneralSection })));
function General() {
  return (
    <Lazy>
      <GeneralLazy />
    </Lazy>
  );
}
const TimeTrackingLazy = lazy(() =>
  import("./sections/TimeTracking").then((m) => ({ default: m.TimeTrackingSection })),
);
function TimeTracking() {
  return (
    <Lazy>
      <TimeTrackingLazy />
    </Lazy>
  );
}
const FinancesLazy = lazy(() => import("./sections/Finances").then((m) => ({ default: m.FinancesSection })));
function Finances() {
  return (
    <Lazy>
      <FinancesLazy />
    </Lazy>
  );
}
const TimePlanningLazy = lazy(() => import("./sections/Other").then((m) => ({ default: m.TimePlanningSection })));
function TimePlanning() {
  return (
    <Lazy>
      <TimePlanningLazy />
    </Lazy>
  );
}
const UserActivityLazy = lazy(() => import("./sections/Other").then((m) => ({ default: m.UserActivitySection })));
function UserActivity() {
  return (
    <Lazy>
      <UserActivityLazy />
    </Lazy>
  );
}
const KioskLazy = lazy(() => import("./sections/Other").then((m) => ({ default: m.KioskSection })));
function Kiosk() {
  return (
    <Lazy>
      <KioskLazy />
    </Lazy>
  );
}
const SecurityLazy = lazy(() => import("./sections/Other").then((m) => ({ default: m.SecuritySection })));
function Security() {
  return (
    <Lazy>
      <SecurityLazy />
    </Lazy>
  );
}
const AccountsLazy = lazy(() => import("./sections/Accounts").then((m) => ({ default: m.AccountsSection })));
function Accounts() {
  return (
    <Lazy>
      <AccountsLazy />
    </Lazy>
  );
}
const PermissionsLazy = lazy(() => import("./sections/Permissions").then((m) => ({ default: m.PermissionsSection })));
function Permissions() {
  return (
    <Lazy>
      <PermissionsLazy />
    </Lazy>
  );
}
const IntegrationsLazy = lazy(() =>
  import("./sections/Integrations").then((m) => ({ default: m.IntegrationsSection })),
);
function Integrations() {
  return (
    <Lazy>
      <IntegrationsLazy />
    </Lazy>
  );
}
const ImportExportLazy = lazy(() =>
  import("./sections/ImportExport").then((m) => ({ default: m.ImportExportSection })),
);
function ImportExport() {
  return (
    <Lazy>
      <ImportExportLazy />
    </Lazy>
  );
}

// Each section is its own chunk; the shell renders them without a Suspense boundary, so Lazy provides one.
const sections: SettingsSection[] = [
  { hash: "general", label: s.sections.general, group: 1, order: 1, Component: General },
  { hash: "time-tracking", label: s.sections.timeTracking, group: 1, order: 2, Component: TimeTracking },
  { hash: "finances", label: s.sections.finances, group: 1, order: 3, Component: Finances },
  { hash: "time-planning", label: s.sections.timePlanning, group: 1, order: 4, Component: TimePlanning },
  { hash: "user-activity", label: s.sections.userActivity, group: 1, order: 5, Component: UserActivity },
  { hash: "kiosk", label: s.sections.kiosk, group: 1, order: 6, Component: Kiosk },
  { hash: "security", label: s.sections.security, group: 1, order: 7, Component: Security },
  { hash: "accounts", label: s.sections.accounts, group: 2, order: 1, Component: Accounts },
  { hash: "permissions", label: s.sections.permissions, group: 2, order: 2, Component: Permissions },
  { hash: "integrations-addons", label: s.sections.integrations, group: 3, order: 1, Component: Integrations },
  { hash: "import", label: s.sections.import, group: 3, order: 2, Component: ImportExport },
];

const shellRoutes: RouteObject[] = [
  {
    path: "/user/settings",
    handle: { title: "User" },
    lazy: () => import("./pages/ProfilePage").then((m) => ({ Component: m.ProfilePage })),
  },
  {
    path: "/user/settings/delete",
    handle: { title: "User" },
    lazy: () => import("./pages/DeleteAccountPage").then((m) => ({ Component: m.DeleteAccountPage })),
  },
  {
    path: "/user/preferences",
    handle: { title: "User" },
    lazy: () => import("./pages/PreferencesPage").then((m) => ({ Component: m.PreferencesPage })),
  },
  {
    path: "/workspaces/:workspaceId/settings/time-tracking/custom-fields",
    handle: { title: "Workspaces" },
    lazy: () => import("./pages/CustomFieldsPage").then((m) => ({ Component: m.TimeEntryCustomFieldsPage })),
  },
  {
    path: "/workspaces/:workspaceId/settings/accounts/custom-fields",
    handle: { title: "Workspaces" },
    lazy: () => import("./pages/CustomFieldsPage").then((m) => ({ Component: m.UserCustomFieldsPage })),
  },
  {
    path: "/workspaces/:workspaceId/settings/import/:importId",
    handle: { title: "Workspaces" },
    lazy: () => import("./pages/ImportSummaryPage").then((m) => ({ Component: m.ImportSummaryPage })),
  },
];

export const settingsModule: AppModule = {
  name: "settings",
  routes: { shell: shellRoutes },
  settingsSections: sections,
};
